<template>
  <v-card flat class="localitiesCard pa-5">
    <p class="legend">Locais com mais atendimentos</p>
    <v-row class="d-flex">
      <v-col sm="2" v-for="item in filterByPlaceType" :key="item.place">
        <TreatmentLocalities :localitie="item.name" :treatmentNumber="item.count" />
      </v-col>
      <v-col sm="2">
        <v-select
          v-model="selectValue"
          class="select"
          height="56"
          :items="selectOptions"
          :value="selectValue"
          label="Local"
          solo
          flat
        >
          <template slot="item" slot-scope="data">
            <span class="select">{{ data.item }}</span>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TreatmentLocalities from "@/components/atoms/Home/treatment-localities";

export default {
  components: {
    TreatmentLocalities
  },
  data() {
    return {
      selectOptions: ["Estado", "Cidade"],
      selectValue: "Estado",
      statesWithMostCases: [],
      citiesWithMostCases: []
    };
  },
  computed: {
    filterByPlaceType() {
      if (this.selectValue === "Estado") {
        return this.statesWithMostCases.slice(0).sort((a, b) => {
          return b.count - a.count;
        });
      } else
        return this.citiesWithMostCases.slice(0).sort((a, b) => {
          return b.count - a.count;
        });
    }
  },
  beforeMount() {
    this.statesWithMostCases = this.$store.getters.mostRecurrentStates;
    this.citiesWithMostCases = this.$store.getters.mostRecurrentCities;
  }
};
</script>

<style scoped>
.localitiesCard {
  background: #ffffff;
  border-radius: 10px;
}

.legend {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}

.select {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>

